import { useSdhTransitionTour } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import Button from 'app/src/kit/Button'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'
import { noop } from 'lodash-es'
import React from 'react'
import { styled } from 'styled-components'

const Card = styled(Flex)`
  border-radius: ${(p) => p.theme.spacings.lg}px;
`

const FullWidthButton = styled(Button)`
  width: 100%;
`

const FlexedButton = styled(Button)`
  flex: 1;
`

const SDHTransitionTour: React.FC = () => {
  const { t } = useIntl()
  const { currentStep, nextStep, prevStep, isFirstStep, isLastStep, finishState } =
    useSdhTransitionTour(noop)

  return (
    <Card
      $flexDirection='column'
      $p='lg'
      $backgroundColor='primary.500'
      $gap='lg'
      $alignItems='center'
      $maxWidth={360}
    >
      <Text $fontWeight='bold' $color='grayscale.white' $textAlign='center'>
        {t(currentStep.title)}
      </Text>
      <Text $color='grayscale.white' $textAlign='center'>
        {t(currentStep.description)}
      </Text>
      {isFirstStep ? (
        <FullWidthButton
          backgroundColor='grayscale.white'
          color={'primary.500'}
          onPress={nextStep}
          variant='small'
        >
          {t('actions.lets_go')}
        </FullWidthButton>
      ) : isLastStep ? (
        <Flex $justifyContent='space-between' $alignItems='center' $gap={'md'} $width='100%'>
          <FlexedButton
            color='grayscale.white'
            backgroundColor={'primary.500'}
            onPress={prevStep}
            variant='small'
          >
            {t('actions.previous')}
          </FlexedButton>
          <FlexedButton
            backgroundColor='grayscale.white'
            color={'primary.500'}
            onPress={nextStep}
            variant='small'
            isLoading={isLastStep && finishState.isPending}
          >
            {t('actions.terminate')}
          </FlexedButton>
        </Flex>
      ) : (
        <Flex $justifyContent='space-between' $alignItems='center' $gap={'md'} $width='100%'>
          <FlexedButton
            color='grayscale.white'
            backgroundColor={'primary.500'}
            onPress={prevStep}
            variant='small'
          >
            {t('actions.previous')}
          </FlexedButton>
          <FlexedButton
            backgroundColor='grayscale.white'
            color={'primary.500'}
            onPress={nextStep}
            variant='small'
            isLoading={isLastStep && finishState.isPending}
            IconRight={Icons.ArrowRight}
          >
            {t('actions.next')}
          </FlexedButton>
        </Flex>
      )}
    </Card>
  )
}

export default SDHTransitionTour
